export default __webpack_public_path__ + "static/media/wholeNote.244dc5f5.svg";